import { useEffect, useState } from 'react';

// Operational indicators are product features, independent of retired visual themes.
export function useActiveTheme(): string {
  const [theme, setTheme] = useState(
    () => document.documentElement.getAttribute('data-theme') || 'experviser'
  );

  useEffect(() => {
    const target = document.documentElement;
    const observer = new MutationObserver(() => {
      setTheme(target.getAttribute('data-theme') || 'experviser');
    });
    observer.observe(target, { attributes: true, attributeFilter: ['data-theme'] });
    return () => observer.disconnect();
  }, []);

  return theme;
}

export function useOperationalIndicators(): boolean {
  return useActiveTheme() === 'fjord';
}
